// extracted by mini-css-extract-plugin
export var cardSelected = "_e9-2";
export var image = "_e9-1";
export var table = "_e9-0";